import { Icon } from "../../../components/BaseComponents/Icon";

export const ChevronLeftIcon = (props) => (
	<Icon viewBox="0 0 18 18" fill="none" {...props}>
		<path
			d="M6 9a.994.994 0 00.293.705l3.991 3.99a1 1 0 101.436-1.387l-.025-.024L8.409 9l3.286-3.285A1 1 0 0010.31 4.28l-.024.025-3.992 3.99A.994.994 0 006 9z"
			fill="currentColor"
		/>
	</Icon>
);
